import { CustomersStepTypeEnum, CustomersStepTypeEnumPaths } from '@/shared/endpoints/customers/models/enums';
import AboutYou from './pages/about-you';
import Insurance from './pages/insurance';
import Medbox from './pages/medbox';
import Review from './pages/review';
import ThankYou from '../thankYou';
import { IHueOption } from '@/shared/types/interfaces';

import BlueSkyImage from '@/assets/medbox-images/min/blue-sky.png';
import EmeraldLakeImage from '@/assets/medbox-images/min/emerald-lake.png';
import PineForestImage from '@/assets/medbox-images/min/pine-forest.png';
import RoseWaterImage from '@/assets/medbox-images/min/rose-water.png';
import LilacBlossomImage from '@/assets/medbox-images/min/lilac-blossom.png';
import { isEnoughMedicationsToPassOnboarding } from '@/shared/helpers/main';
import { ICustomersGetResponse } from '@/shared/endpoints/customers';

export interface OnboardingStep {
    name: string;
    shortName?: string;
    type: CustomersStepTypeEnum;
    title?: string;
    path: CustomersStepTypeEnumPaths;
    visible: boolean;
    indexAttr?: number;
    checklist?: ((user: ICustomersGetResponse) => boolean)[];
}

export type OnboardingStepsArray = OnboardingStep[];

export const ONBOARDING_STEPS: OnboardingStepsArray = [
    {
        name: 'About You',
        shortName: 'About',
        type: CustomersStepTypeEnum.AboutYou,
        title: 'About You',
        path: CustomersStepTypeEnumPaths[CustomersStepTypeEnum.AboutYou],
        visible: true
    },
    {
        name: 'Insurance',
        type: CustomersStepTypeEnum.Insurance,
        title: 'Your Insurance',
        path: CustomersStepTypeEnumPaths[CustomersStepTypeEnum.Insurance],
        visible: true
    },
    {
        name: 'My MedBox',
        shortName: 'MedBox',
        type: CustomersStepTypeEnum.Prescriptions,
        title: 'Add Medications',
        path: CustomersStepTypeEnumPaths[CustomersStepTypeEnum.Prescriptions],
        visible: true
    },
    {
        name: 'Review',
        type: CustomersStepTypeEnum.Review,
        title: 'Review & Submit',
        path: CustomersStepTypeEnumPaths[CustomersStepTypeEnum.Review],
        visible: true,
        checklist: [isEnoughMedicationsToPassOnboarding]
    },
    {
        name: 'Thank You',
        type: CustomersStepTypeEnum.ThankYou,
        path: CustomersStepTypeEnumPaths[CustomersStepTypeEnum.ThankYou],
        visible: false
    }
];

export const ONBOARDING_STEP_COMPONENT_MAP: any = {
    [CustomersStepTypeEnumPaths.ABOUT_YOU]: AboutYou,
    [CustomersStepTypeEnumPaths.INSURANCE]: Insurance,
    [CustomersStepTypeEnumPaths.PRESCRIPTIONS]: Medbox,
    [CustomersStepTypeEnumPaths.REVIEW]: Review,
    [CustomersStepTypeEnumPaths.THANKYOU]: ThankYou
};

export const STYLE_CLASS_COMPONENT_MAP: any = {
    [CustomersStepTypeEnumPaths.ABOUT_YOU]: 'ABOUT_YOU',
    [CustomersStepTypeEnumPaths.INSURANCE]: 'INSURANCE',
    [CustomersStepTypeEnumPaths.PRESCRIPTIONS]: 'MY_MEDBOX',
    [CustomersStepTypeEnumPaths.REVIEW]: 'REVIEW',
    [CustomersStepTypeEnumPaths.THANKYOU]: 'THANK_YOU'
};

export enum HueEnum {
    EMERALD_LAKE,
    PINE_FOREST,
    BLUE_SKY,
    ROSE_WATER,
    LILAC_BLOSSOM
}

export const HueOption: IHueOption[] = [
    { id: HueEnum.EMERALD_LAKE, name: 'Emerald Lake', src: EmeraldLakeImage },
    { id: HueEnum.PINE_FOREST, name: 'Pine Forest', src: PineForestImage },
    { id: HueEnum.BLUE_SKY, name: 'Blue Sky', src: BlueSkyImage },
    { id: HueEnum.ROSE_WATER, name: 'Rose Water', src: RoseWaterImage },
    { id: HueEnum.LILAC_BLOSSOM, name: 'Lilac Blossom', src: LilacBlossomImage }
];

export const PREGNANCY_OPTIONS = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
];

export const allergiesAnswers = [
    { label: 'Yes', value: 1 },
    { label: 'No known allergies', value: 2 },
    {
        label: 'I am unsure at this time',
        value: 3
    }
];

export const conditionsAnswers = [
    { label: 'Yes', value: 1 },
    { label: 'No', value: 2 },
    {
        label: 'Not sure at this time',
        value: 3
    }
];

export enum UserGender {
    MALE = 'M',
    FEMALE = 'F'
}

export const GENDERS = [
    { label: 'Male', value: UserGender.MALE },
    { label: 'Female', value: UserGender.FEMALE }
];
